import { render, staticRenderFns } from "./toastmessage.vue?vue&type=template&id=6a48a4ac"
import script from "./toastmessage.vue?vue&type=script&lang=js"
export * from "./toastmessage.vue?vue&type=script&lang=js"
import style0 from "./toastmessage.vue?vue&type=style&index=0&id=6a48a4ac&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a48a4ac')) {
      api.createRecord('6a48a4ac', component.options)
    } else {
      api.reload('6a48a4ac', component.options)
    }
    module.hot.accept("./toastmessage.vue?vue&type=template&id=6a48a4ac", function () {
      api.rerender('6a48a4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/siteheaderstandard/assets/frontend/components/toastmessage.vue"
export default component.exports